
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import BsyDashboardCenter from '../BsyDashboardCenter'
import BsyDashboardApp from '../BsyDashboardApp'

import './index.css';
import BsyAppPane from "../../BsyAppPane";
import BsyEntryView from "../../BsyEntryView";
import BsyQueryForm from "../../BsyQueryForm";
import BsyFlowMessage from "../../BsyFlowMessage";
import BsyDataView from "../../BsyDataView";
import { BsyConfig } from "../../../global/BsyConfig";
import BsyMsgDataView from "../../BsyMsgDataView";
import BsyDashboardInstallApp from "../BsyDashboardInstallApp";
import BsyDashboardInstallAppMobaile from "../BsyDashboardInstallApp/indexMobaile";
import BsyDataManagePage from "../../BsyDataManagePage";
import BsyDashboardFlowCenter from "../BsyDashboardFlowCenter";

class BsyDashboardContent extends Component {

    static defaultProps = {
        appEmpty: true,
        dockItem: [],
        dockCorp: [],
    };
    constructor(props) {
        super(props)
        this.state = {
            apps: props.apps,
            dashboardMode: props.dashboardMode,
            components: props.components,
            appid: props.appid,
            dockItem: props.dockItem,
            dockCorp: props.dockCorp,
            entryid: props.entryid,
            type: props.type,
            routePath: props.routePath,
            appEmpty: props.appEmpty,
        }
        this.contentEntryRef = React.createRef();
    }

    selectApp = (appinfo) => {
        if (this.props) {
            this.props.onSelectApp(appinfo)
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const { appid, type, entryid, groupid } = nextProps.match.params;

        const ppp = {
            ...this.state,
            ...nextProps,
            appid: appid,
            type: type,
            routePath: nextProps.routePath,
            entryid: entryid,
            groupid: groupid,
            appsCache: nextProps.appsCache,
        }
        this.setState(ppp)
    }

    componentDidMount() {
        // console.log(this.props)
    }

    renderContent = () => {

        const { apps, components, appid, entryid, type, routePath, dockItem, dockCorp } = this.state;

        switch (routePath) {
            case BsyConfig().RouteEnum.RouteR2: //全部应用
            case BsyConfig().RouteEnum.RouteR3: //全部应用
                {
                    return <div className={"content-pane"}  >
                        <BsyAppPane
                            // onSelectApp={this.selectApp}
                            apps={apps}
                            dockItem={dockItem}
                        />
                    </div>
                }
            case BsyConfig().RouteEnum.RouteR4: //应用访问
            case BsyConfig().RouteEnum.RouteR5:
                {
                    return <div className={"content-pane"}  >
                        <BsyDashboardApp apps={apps}
                            dockItem={dockItem}
                            appid={appid}
                            entryid={entryid}
                            type={type}
                            routePath={routePath}
                        />
                    </div>
                }
            case BsyConfig().RouteEnum.RouteR8: // 内链 外链
            case BsyConfig().RouteEnum.RouteR9: {
                return <BsyDataView />
            }
            case BsyConfig().RouteEnum.RouteR6: {  //流程消息
                return <div className={"content-pane message-view"}  >
                    <BsyFlowMessage />
                </div>
            }
            case BsyConfig().RouteEnum.RouteR7: {  //流程消息
                return <div className={"content-pane message-view"}  >
                    <BsyMsgDataView
                        appid={window.FX.STATIC.APPID}
                    />
                </div>
            }
            case BsyConfig().RouteEnum.RouteR10: { //表单内链
                return <div className={"content-pane data-view "}  >
                    <BsyEntryView />
                </div>
            }
            case BsyConfig().RouteEnum.RouteR12: { //应用安装
                return <div className={"content-pane data-view "}  >
                    {
                        window.screen.width<1360 && <BsyDashboardInstallAppMobaile/>
                    }
                    {
                        window.screen.width>=1360 && <BsyDashboardInstallApp/>  
                    }
                </div>
            }
            case BsyConfig().RouteEnum.RouteR13: {//表单数据管理
                return <BsyDataManagePage />
            }
            case window.BsyConfig.RouteEnum.TEAMTODO: return <BsyDashboardFlowCenter type={"todo"} /> 
            case window.BsyConfig.RouteEnum.TEAMCC: return <BsyDashboardFlowCenter type={"cc"} /> 
            case window.BsyConfig.RouteEnum.TEAMTRANSACTORS: return <BsyDashboardFlowCenter type={"transactors"} /> 
            case window.BsyConfig.RouteEnum.TEAMCREATE: return <BsyDashboardFlowCenter type={"create"} /> 
            case window.BsyConfig.RouteEnum.TEAMLAUNCH: return <BsyDashboardFlowCenter type={"launch"} /> 
            case BsyConfig().RouteEnum.RouteR14: {//表单查询
                return <div className={"content-pane data-view "}  >
                    <BsyQueryForm />
                </div>
            }
            default: {
                return <div className={"content-pane"} >
                    <BsyDashboardCenter
                        components={components}
                        dockCorp={dockCorp}
                        dockItem={dockItem}
                        apps={apps}
                    />
                </div>
            }
        }
    }

    render() {
        const { appEmpty } = this.state;
        return (
            <>
                {
                    // !appEmpty ? 
                    this.renderContent()
                    // : 
                    // <div className="content-pane-empty"
                    // >
                    //     <div className="content-pane-empty-layout">
                    //         <div className="emptyCont">
                    //             {
                    //                 BsyUtils.isSysManager() || BsyUtils.isCorpOwn() ? <>
                    //                     <img src={emptyPic} alt=""></img>
                    //                     <div className="app-empty-tip">{React.language('app.empty.tip1')}</div>
                    //                     <div className="row">
                    //                         <a className="btn-create" href="/bsymember/appstore">{React.language('app.create')}</a>
                    //                     </div>
                    //                 </> : <> <img src={imgkfptweihuoqu} alt=""></img>
                    //                     <div className="app-empty-tip">{React.language('app.noAuth.operate')}</div></>
                    //             }
                    //         </div>

                    //     </div>

                    // </div>
                }
            </>

        )
    }
}

export default withRouter(BsyDashboardContent)